/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { useState } from "react";

import { css, cx } from "@panda/css";
import { HStack } from "@panda/jsx";
import { Toggle } from "@eds-web/react/Toggle";

export type TabListProps = {
	tabs?: {
		label: string;
		value: string;
	}[];
	onchange?: (tab: string) => void;
};

export function TabList({ tabs = [], onchange }: TabListProps): React.JSX.Element {
	const [selected, setSelected] = useState(tabs[0]?.value);
	const onClick = (value: string): void => {
		setSelected(value);
		if (onchange) {
			onchange(value);
		}
	};

	if (tabs?.length === 0) {
		return <></>;
	}

	return (
		<HStack
			className={cx(
				css({
					overflowX: "auto",
					whiteSpace: "nowrap",
					scrollbarWidth: "none",
					"&::-webkit-scrollbar": {
						display: "none",
					},
				}),
				"tab-list",
			)}
			gap="eds.dimension.12"
			role="tablist"
		>
			{tabs.map(({ label, value }) => (
				<Toggle
					key={`tab-${value}`}
					label={label}
					aria-label={label}
					role="tab"
					removable={false}
					selected={value === selected}
					aria-pressed={undefined}
					onChange={(selected: boolean) => {
						if (selected) {
							onClick(value);
						}
					}}
					className={
						value === selected
							? css({
									bgColor: "eds.fill.contrast.default!",
									borderColor: "eds.fill.contrast.default!",
									"& span": {
										color: "eds.palette.static.black!",
									},
								})
							: ""
					}
				/>
			))}
			<div
				className={css({
					position: "sticky",
					paddingStart: "eds.dimension.56",
					height: "eds.dimension.40",
					right: "0",
					pointerEvents: "none",
					background: "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(24,24,28,1) 80%)",
				})}
			>
				&nbsp;
			</div>
		</HStack>
	);
}
